import React, { useState } from "react";
import styles from "./Components.module.css";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import OverviewComponent from "./Overview/Overview";
import IngredientsMaterial from "./Ingredients&Material/I&M";
import RecipeComponent from "./Recipe/Recipe";
import OrderHistoryComponent from "./OrderHistory/OrderHistory";




const Components = () => {
  const navigate = useNavigate();
  const options1 = [
    { id: 1, name: "Overview" },
    { id: 2, name: "Ingredients & Material" },
    { id: 3, name: "Recipe" },
    { id: 4, name: "Order History" },
  ];
  const [focusedTab1, setFocusedTab1] = useState(options1[0]);
  // const options2 = [
  //   { id: 1, name: "Ingredients" },
  //   { id: 2, name: "Materials" },
  // ];
  // const [focusedTab2, setFocusedTab2] = useState(options2[0]);

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Brownie Base"}
        showBackIcon={true}
        showControlButtons

      >
        <TopTabComponent
          options={options1}
          focused={focusedTab1}
          setFocused={setFocusedTab1}
          TopTabListStyle={styles.TopTabListStyle1}
        />
      </HeaderComponent>

      {
        focusedTab1?.name === options1[0].name ?
          <OverviewComponent /> :
          focusedTab1?.name === options1[1].name ?
            <IngredientsMaterial /> :
            focusedTab1?.name === options1[2].name ?
              <RecipeComponent /> :
              focusedTab1?.name === options1[3].name ?
                <OrderHistoryComponent />
                : null
      }



    </div>
  );
};

export default Components;
